import React, { Component } from 'react';
// import * as firebase from 'firebase';
import firebase from '../helper/firebase';

import { Link } from 'react-router-dom';

import {
	Button,
	Card,
	CardActions,
	CircularProgress,
	Divider,
	IconButton
} from 'material-ui';

import List, {
	ListItem,
	ListItemText,
	ListItemSecondaryAction
} from 'material-ui/List';

import Fade from 'material-ui/transitions/Fade';

import FileUploadIcon from 'material-ui-icons/FileUpload';
import ClearIcon from 'material-ui-icons/Clear';
import SaveIcon from 'material-ui-icons/Save';
import CheckIcon from 'material-ui-icons/Check';

import Head from '../components/Head';
import Snack from '../components/Snack';
import JobCardHeader from '../components/JobCardHeader';
import UnauthorizedText from '../components/UnauthorizedText';
import LoggedOutCard from '../components/LoggedOutCard';

import { Title } from '../helper/consts';

const style = {
	body: {
		position: 'relative'
	},
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	emailsLoading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		position: 'relative',
		left: 'calc(50% - 37.5px)'
	},
	uploadBtn: {
		padding: '0'
	},
	label: {
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '11px 16px',
		cursor: 'pointer'
	},
	unauthorizedText: {
		justifyContent: 'center',
		alignItems: 'center'
	}
};

export default class BatchInvite extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loggedIn: false,
			authLoading: true,
			loading: true,
			loaded: false,
			snackStatus: false,
			snackMessage: '',
			invites: [],
			job: {},
			offer: {}
		};
	}

	componentWillUnmount() {
		if (
			!this.state.loading &&
			Object.keys(this.state.job).length !== 0 &&
			Object.keys(this.state.offer).length !== 0
		) {
			const { job, offer } = this.state;
			firebase
				.database()
				.ref(`invites/${job.jid}/${offer.oid}`)
				.off();
		}
	}

	componentDidMount() {
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.getInfo(this.props.match.params.oid);
				this.setState({
					uid: user.uid,
					jid: this.props.match.params.jid,
					user: user.providerData[0],
					loggedIn: true,
					authLoading: false,
					loading: true
				});
			} else {
				firebase
					.database()
					.ref(`invites/${this.state.job.jid}/${this.state.offer.oid}`)
					.off();
				this.setState({
					user: {},
					uid: '',
					loggedIn: false,
					authLoading: false,
					loading: true,
					loaded: false,
					snackStatus: false,
					snackMessage: '',
					invites: [],
					job: {},
					offer: {}
				});
			}
		});
	}

	getInfo = oid => {
		const ref = firebase.database().ref();
		firebase
			.firestore()
			.collection('offers')
			.doc(oid)
			.get()
			.then(offerSnap => {
				let data = {};
				if (offerSnap.data() !== null) {
					data.offer = offerSnap.data();
					console.log(data);
					return data;
				} else {
					this.setState({
						job: {},
						offer: {},
						snackStatus: true,
						snackMessage: 'Error: Please try again',
						loading: false
					});
					return Promise.reject();
				}
			})
			.then(data => {
				firebase
					.firestore()
					.collection('jobs')
					.doc(data.offer.jid)
					.get()
					// ref.child(`jobs/${data.offer.jid}`).once('value')
					.then(jobSnap => {
						if (jobSnap.data() !== null) {
							data.job = jobSnap.data();
							return data;
						} else {
							this.setState({
								job: {},
								offer: {},
								snackStatus: true,
								snackMessage: 'Error: Please try again',
								loading: false
							});
							return Promise.reject();
						}
					})
					.then(data => {
						ref.child(`invites/${data.job.jid}/${data.offer.oid}`).on(
							'value',
							inviteSnap => {
								if (inviteSnap.val() !== null) {
									this.setState({
										job: data.job,
										offer: data.offer,
										invites: Object.values(inviteSnap.val()),
										loading: false
									});
								} else {
									this.setState({
										job: data.job,
										offer: data.offer,
										invites: [],
										loading: false
									});
								}
							},
							inviteErr => {
								this.setState({
									invites: [],
									job: {},
									offer: {},
									snackStatus: true,
									snackMessage: `Error: ${inviteErr}`,
									loading: false
								});
							}
						);
					})
					.catch(error => {
						this.setState({
							invites: [],
							job: {},
							offer: {},
							snackStatus: true,
							snackMessage: `Error: ${error}`,
							loading: false
						});
					});
			});
	};

	upload = e => {
		let file = e.target.files[0];
		if (file) {
			if (file.type.match('text/csv')) {
				this.setState({ loaded: false, loading: true });
				let reader = new FileReader(file);
				reader.onloadend = e => {
					this.prepEmails(reader.result);
					this.setState({
						file,
						fileEmails: reader.result
					});
				};
				if (file !== undefined) {
					reader.readAsText(file);
				}
			} else {
				this.setState({
					snackStatus: true,
					snackMessage:
						'Error: Please upload a comma separated values (csv) file.'
				});
			}
		}
	};

	prepEmails = fileEmails => {
		let emails = fileEmails.split(',');
		let deduped = [];
		let dups = [];
		emails.forEach((email, i) => {
			email = email.replace(/(\r\n|\n|\r)/gm, '');
			if (deduped.indexOf(email) === -1) {
				deduped.push(email);
			} else {
				dups.push(email);
			}
			if (i === emails.length - 1) {
				this.setState({ dups, emails: deduped, loaded: true, loading: false });
			}
			if (dups.length !== 0) {
				this.setState({
					snackStatus: true,
					snackMessage: `${dups.length} duplicate emails were removed.`
				});
			}
		});
	};

	clear = () => {
		this.setState({ emails: [], loaded: false, fileEmails: '' });
		// this.refs.input.value = '';
		document.getElementById('input').value = '';
	};

	closeSnack = () => {
		this.setState({ snackStatus: false, snackMessage: '' });
	};

	save = () => {
		const { emails, job, offer, invites } = this.state;
		const ref = firebase.database().ref();
		let update = {};
		let counter = 0;
		emails.forEach((email, i) => {
			counter++;
			if (invites.indexOf(email) === -1) {
				const key = ref.child(`invites/${job.jid}/${offer.oid}`).push().key;
				update[`${key}`] = email;
			}
			if (counter === emails.length) {
				ref
					.child(`invites/${job.jid}/${offer.oid}`)
					.update(update)
					.then(() => {
						this.setState({
							invited: true,
							snackMessage: 'Success: Invites Sent.'
						});
					})
					.catch(err => {
						console.log(err);
						this.setState({ snackStatus: true, snackMessage: `Error: ${err}` });
					});
			}
		});
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Batch Invite | ${Title}`} />
				<div id={this.state.loggedIn ? 'loggedInBody' : null} className="body">
					{(this.state.loading &&
						this.state.authLoading &&
						!this.state.loggedIn) ||
					(this.state.loading &&
						!this.state.authLoading &&
						this.state.loggedIn) ? (
						<CircularProgress style={style.loading} size={75} />
					) : null}
					{this.state.loading &&
					!this.state.authLoading &&
					!this.state.loggedIn ? (
						<LoggedOutCard />
					) : null}
					{!this.state.loading &&
					!this.state.authLoading &&
					this.state.loggedIn ? (
						<div className="body">
							{Object.keys(this.state.job).length !== 0 &&
							Object.keys(this.state.offer).length !== 0 ? (
								<Fade in={true}>
									<Card className="card">
										<JobCardHeader job={this.state.job} />
										<Divider light />
										{this.state.loading ? (
											<CircularProgress style={style.emailsLoading} size={75} />
										) : null}
										{this.state.loaded ? (
											<Fade in={true}>
												<List className="container" subheader>
													{this.state.emails.map((email, i) => {
														return (
															<ListItem
																key={email}
																disabled={
																	this.state.invites.indexOf(email) !== -1
																}
															>
																<ListItemText primary={`${i + 1}: ${email}`} />
																{this.state.invites.indexOf(email) !== -1 ? (
																	<ListItemSecondaryAction>
																		<IconButton disabled aria-label="Invited">
																			<CheckIcon />
																		</IconButton>
																	</ListItemSecondaryAction>
																) : null}
															</ListItem>
														);
													})}
												</List>
											</Fade>
										) : null}
										<CardActions className="cardActions">
											{!this.state.loaded && (
												<Button
													disableRipple
													style={style.uploadBtn}
													className="cardActionsBtn"
													raised
													color="default"
												>
													<label style={style.label} htmlFor="input">
														Upload
														<FileUploadIcon />
													</label>
												</Button>
											)}
											{this.state.loaded &&
												!this.state.invited && (
													<Button
														disableRipple
														className="cardActionsBtn"
														onClick={this.save}
														raised
														color="default"
													>
														Save
														<SaveIcon />
													</Button>
												)}
											{this.state.loaded &&
												!this.state.invited && (
													<Button
														disableRipple
														className="cardActionsBtn"
														onClick={this.clear}
														raised
														color="default"
													>
														Clear
														<ClearIcon />
													</Button>
												)}
											{this.state.loaded &&
												this.state.invited && (
													<Link to={'/BatchInvites'}>
														<Button
															disableRipple
															className="cardActionsBtn"
															raised
															color="default"
														>
															Done
														</Button>
													</Link>
												)}
										</CardActions>
									</Card>
								</Fade>
							) : null}
							{Object.keys(this.state.offer).length === 0 &&
							Object.keys(this.state.job).length === 0 ? (
								<div className="body" style={style.unauthorizedText}>
									<UnauthorizedText
										text="Forbidden"
										subText="There appears to have been an error. Please try again."
									/>
								</div>
							) : null}
						</div>
					) : null}
					{!this.state.loading &&
					!this.state.authLoading &&
					this.state.loggedIn &&
					!this.state.loading &&
					Object.keys(this.state.job).length !== 0 &&
					Object.keys(this.state.offer).length !== 0 ? (
						<input
							onChange={this.upload}
							accept="csv"
							style={{ display: 'none' }}
							id="input"
							multiple
							type="file"
						/>
					) : null}
					<Snack
						snackStatus={this.state.snackStatus}
						snackMessage={this.state.snackMessage}
						closeSnack={() => {
							this.closeSnack();
						}}
					/>
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/BatchInvite.js